import {
  ISelectedShipments,
  IShipmentServices,
  IMarketPlaceRadios,
  Operation,
} from "store/reducers/shipmentServices.reducers";
export interface IShipmentRule {
  shipment: {
    op: "equal";
    value: string;
  };
  seller?: {
    op: Operation;
    value: string | string[];
  };
}

export interface ISelectedShipment {
  value: string;
  sellerType: string;
  label: string;
}

export interface IShipmentFiles {
  [sellerName: string]: string[];
}

// This function helps to create the Shipment Rule's structure

export const generateShipmentRules = (
  selectedShipments: ISelectedShipments[],
  values: IMarketPlaceRadios,
  getValue: (keys: string[]) => string | Date
) => {
  return selectedShipments.map((shipmentInfo) => {
    const shipmentRule = {
      shipment: {
        op: "equal",
        value: shipmentInfo.value,
      },
    };

    if (
      shipmentInfo.sellerType === "RETAIL" ||
      shipmentInfo.sellerType === "B2B"
    ) {
      const sellerValue =
        shipmentInfo.sellerType === "RETAIL" ? "Carrefour" : "B2B";
      return {
        ...shipmentRule,
        seller: {
          op: "in",
          value: [sellerValue],
        },
      };
    } else {
      const key = shipmentInfo.value;
      const op = values[key];

      if (!op || op === "allSeller") {
        return shipmentRule;
      } else {
        return {
          ...shipmentRule,
          seller: {
            op: op,
            value: getValue(["restrictions", "shipmentRulesFiles", key]),
          },
        };
      }
    }
  });
};

// Below function is parsing back the values which we need while editing

export const parseShipmentRules = (
  shipmentRules: IShipmentRule[],
  shipmentServices: IShipmentServices[]
): {
  selectedShipments: ISelectedShipment[];
  values: IMarketPlaceRadios;
  shipmentRulesFiles: IShipmentFiles;
} => {
  const selectedShipments: ISelectedShipment[] = [];
  const values: IMarketPlaceRadios = {};
  const shipmentRulesFiles: IShipmentFiles = {};

  shipmentRules?.forEach((rule) => {
    let shipmentValue = rule?.shipment?.value;
    const seller = rule?.seller;

    // Try to match the shipment in the service list
    const matchedService = shipmentServices.find(
      (service) => service?.name === shipmentValue
    );

    // Default label: use displayName if available, else fallback to shipment value
    let label = matchedService?.displayName ?? shipmentValue;

    // Special case: B2B
    if (
      seller &&
      seller.op === "in" &&
      Array.isArray(seller.value) &&
      seller.value.length === 1 &&
      seller.value[0] === "B2B"
    ) {
      selectedShipments.push({
        value: shipmentValue,
        sellerType: "B2B",
        label: "B2B",
      });
      return;
    }

    // Special case: RETAIL
    if (
      seller &&
      seller.op === "in" &&
      Array.isArray(seller.value) &&
      seller.value.length === 1 &&
      seller.value[0] === "Carrefour"
    ) {
      selectedShipments.push({
        value: shipmentValue,
        sellerType: "RETAIL",
        label,
      });
      return;
    }

    // No seller then treat as allSeller
    if (!seller) {
      selectedShipments.push({
        value: shipmentValue,
        sellerType: shipmentValue,
        label,
      });
      values[shipmentValue] = "allSeller";
      return;
    }

    // Custom case
    selectedShipments.push({
      value: shipmentValue,
      sellerType: shipmentValue,
      label,
    });
    values[shipmentValue] = seller.op;
    shipmentRulesFiles[shipmentValue] = seller.value as string[];
  });

  return { selectedShipments, values, shipmentRulesFiles };
};

// Below function helps handle older coupons when seller id is carrefour

export const addShipmentRulesIfSellerIdCarrefour = (shipmentServices :IShipmentServices[]) => {
  const retailShipments = shipmentServices
  .filter(service => service.sellerType === "RETAIL")
  .map(service => {
    if(service.name === "STANDARD"){
      return "SLOTTED"
    }else{
      return service.name
    }
  });
  
  return retailShipments?.map((seller) => {
    return {
      shipment: {
        op: "equal",
        value: seller,
      },
      seller: {
        op: "in",
        value: ["Carrefour"],
      },
    };
  });
};


